const topics = [
  { name: '台北娜娜', count: '2.8万讨论', hot: true },
  { name: '莫里秀黑料', count: '3.2万讨论', hot: true },
  { name: '玩偶姐姐', count: '1.9万讨论', hot: true },
  { name: '51吃瓜爆料', count: '4.5万讨论', hot: true },
  { name: '暗网人物专题', count: '1.6万讨论', hot: false },
  { name: '吃瓜每日更新', count: '2.1万讨论', hot: false },
  { name: '独家视频爆料', count: '1.3万讨论', hot: false },
  { name: '八卦深度解读', count: '0.9万讨论', hot: false },
  { name: '热门人物追踪', count: '1.7万讨论', hot: false },
  { name: '社区吃瓜热帖', count: '2.4万讨论', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          热门话题标签
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          大家都在讨论什么？快来加入吃瓜队伍
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-200 cursor-pointer ${
                topic.hot
                  ? 'border-primary-500/30 bg-primary-500/10 text-primary-400 hover:bg-primary-500/20'
                  : 'border-background-200/60 bg-background-50 text-foreground-600 hover:border-primary-500/30 hover:text-primary-400'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-sm"></i>}
              <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
              <span className="text-xs opacity-70">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}